import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { IpBgpSubscriptionDetails } from "../../../pages/subscription-detail/types";

type BgpSap = IpBgpSubscriptionDetails["saps"][number];

@Component({
  selector: "bgp-sap-row",
  templateUrl: "bgp-sap-row.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, FormsModule, TranslatePipe],
})
export class BgpSapRow {
  readonly sap = input.required<BgpSap>();
  readonly index = input.required<number>();

  protected customerDescription = computed(() => this.sap().port?.customerDescription);
  protected locationDescription = computed(() => this.sap().port?.locationDescription);
  protected vlanrange = computed(() => this.sap().vlanrange);
  protected isUntaggedPort = computed(() => !this.vlanrange() || this.vlanrange() === "0");
}
